import api from './api.ts';

export interface CompanyDTO {
  id?: number;
  name: string;
  cnpj: string;
  profitPercent?: number | null;
  annualProfit?: number | null;
  valuation?: number | null;
  annualRevenue?: number | null;
  annualExpenses?: number | null;
  status?: 'active' | 'inactive';
  createdAt?: string;
  updatedAt?: string;
}

export interface CompaniesSummaryResponse {
  totalCompanies: number;
  profitByCompany: { name: string; value: number }[];
  valuationByCompany: { name: string; value: number }[];
  marginByCompany: { name: string; value: number }[];
  revenueByCompany: { name: string; value: number }[];
}

const companiesApi = {
  async list(): Promise<CompanyDTO[]> {
    const { data } = await api.get('/companies');
    return data;
  },

  async get(id: number): Promise<CompanyDTO> {
    const { data } = await api.get(`/companies/${id}`);
    return data;
  },

  async create(payload: CompanyDTO): Promise<CompanyDTO> {
    const { data } = await api.post('/companies', payload);
    return data;
  },

  async update(id: number, payload: Partial<CompanyDTO>): Promise<CompanyDTO> {
    const { data } = await api.put(`/companies/${id}`, payload);
    return data;
  },

  async remove(id: number): Promise<{ id: number }> {
    const { data } = await api.delete(`/companies/${id}`);
    return data;
  },

  async summary(): Promise<CompaniesSummaryResponse> {
    const { data } = await api.get('/companies/summary');
    return data;
  },
};

export default companiesApi;
